// extracted by mini-css-extract-plugin
export default {"left":"ControlLeft_left__-h8ee","image":"ControlLeft_image__RaGNb","info":"ControlLeft_info__NZIbI"};